<template>
    <!-- header -->
    <el-container class="topCenterMenu" id="fb-root">
        <el-header id="myheader">
            <el-row>
                <el-col :span="6" class="logo">
                    <el-card>
                        <img src="../assets/images/searchplus.png" class="image">
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <div>
                            <h2>インデックス型全文検索ツール<br>
                                全文検索くん(Search++)
                            </h2>
                                (最新更新日：2023年08月19日）<br>
                            <a href=http://www.vector.co.jp/magazine/softnews/130524/n1305241.html>ベクター社の評価：”安心感”の高い検索結果</a><br>
                            <a href=http://www.softpedia.com/get/System/File-Management/Search-plus-plus.shtml>Softpedia社の評価：4.0/5.0</a>
                            <!-- facebookSDK -->
                            <br>
                            <div class="fb-share-button" data-href="http://www.searchplusplus.jp" data-layout="button_count"></div>
                            <div class="fb-send" data-href="http://www.searchplusplus.jp"></div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" router>
                        <el-menu-item index="/Index">製品情報</el-menu-item>
                        <el-menu-item index="/feature">特徴</el-menu-item>
                        <el-menu-item index="/release">更新履歴</el-menu-item>
                        <el-menu-item index="/voiceofcustomer">お客様の声</el-menu-item>
                        <el-menu-item index="/download">ご購入</el-menu-item>
                        <el-menu-item index="/link">リンク</el-menu-item>
                        <el-menu-item index="/contact">FAQ</el-menu-item>
                        <el-menu-item index="/register">ユーザ登録</el-menu-item>
                    </el-menu>
                </el-col>
            </el-row>
        </el-header>
        <!-- main -->
        <el-main>
            <router-view></router-view>
        </el-main>
        <!-- footer: Copyright and facebook  -->
        <el-footer>
        <div>
            <div class="copyright">
                <p>Copyright(c) All rights reserved.</p>
            </div>
            <iframe src="http://www.facebook.com/plugins/like.php?href=http%3A%2F%2Fwww.searchplusplus.jp&amp;send=false&amp;layout=standard&amp;width=450&amp;show_faces=true&amp;action=like&amp;colorscheme=light&amp;font&amp;height=80" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:450px; height:80px;" allowTransparency="true">
            </iframe>
        </div>
        </el-footer>
    </el-container>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: ''
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<style scoped>
 #myheader {
    height: 160px !important;
    margin-bottom: 120px;
}
.topCenterMenu {
    float:none;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    max-width: 1440px;
    width:850px
}
.logo {
    /* float: left; */
    margin-right: 20px;
    margin-top: 18px;
    margin-left: 20px;
}
.menu {
    float: left;
}

.el-menu-item {
    font-size: 16px;
    color:rgb(0,145,219) !important;
}

/* .el-menu-item :hover {
    color: navy !important;
} */
    .el-menu-item:hover{
        border-bottom:tomato solid 4px !important;
        /* background-color:ivory !important; */
        color: #38B2FF !important;
        i {
            color: #38B2FF;
        }
    }

    .el-menu-item.is-active {
        border-bottom:tomato solid 4px !important;
        /* background-color: ivory !important; */
        color: #38B2FF !important;
    }
</style>
